export const LOGIN_SLIDER = [
	{
		tag: "SECURITY",
		title: "Your account is protected",
		highlight: "always",
		description:
			"RefApp uses modern security and MFA support to keep your data safe.",
		cta: {
			label: "Back to login",
			href: "/account/login",
		},
	},
];
